export const stops = [
  [0.4, "#d53e4f"],
  [0.45, "#fdae61"],
  [0.5, "#fee08b"],
  [0.55, "#e6f598"],
  [0.6, "#66c2a5"],
  [0.65, "#f46d43"],
];

export const legend = [
  [[0.4, 0.45], "#d53e4f"],
  [[0.45, 0.5], "#fdae61"],
  [[0.5, 0.55], "#fee08b"],
  [[0.55, 0.6], "#e6f598"],
  [[0.6, 0.65], "#66c2a5"],
  // [[0.65, 0.70], "#f46d43"],
];
